import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  advancedSettings: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.CustomStage.AdvancedSettings.advancedSettings`,
    defaultMessage: 'Advanced Settings',
  },
});
